/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Auth Service Access component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import Title from '../../components/common/Title/Title';
import PageLocale from '../../modules/internationalization/components/PageLocale';
import { TranslationFileNamesEnum } from '../../modules/internationalization/constants';
import AuthFormContainer from '../PageAuth/components/AuthForm/AuthFormContainer';
import { PageAuthStyled } from '../PageAuth/styled/PageAuthStyled';
import AuthFormServiceAccessMobile from './components/AuthFormServiceAccessMobile';
import AuthServiceAccessCollapse from './components/AuthServiceAccessCollapse';

interface IPageAuthServiceAccess {
    isServiceAccessLoggedIn: boolean;
}

const PageAuthServiceAccess = (props: IPageAuthServiceAccess) => {
    return (
        <PageAuthStyled className="page-auth__container" data-page-auth="auth">
            <PageLocale fileNames={[TranslationFileNamesEnum.pageAuthServiceAccess]}>
                <Title pageName="login service access"/>
                {
                    props.isServiceAccessLoggedIn
                        ? <AuthFormServiceAccessMobile/>
                        : <AuthFormContainer/>
                }
                {
                    !props.isServiceAccessLoggedIn &&
                    <AuthServiceAccessCollapse />
                }
            </PageLocale>
        </PageAuthStyled>
    );
};

export default PageAuthServiceAccess;
